/**
 * Renders a question.
 */
import classnames from 'classnames';
import isInteger from 'lodash/isInteger';
import React, { PropTypes } from 'react';
import ButtonNext from './ButtonNext';
import ButtonPrevious from './ButtonPrevious';
import QuestionChoice from './QuestionChoice';

function Question({
    currentAnswer,
    currentPosition,
    currentQuestion,
    nextStep,
    previousStep,
    recordChoice,
    totalQuestions,
}) {
  const labels = currentQuestion.fieldAnswerLabels.split('|');
  const choices = labels.map((label, index) =>
    <li key={`question-${currentQuestion.id}-${index}`}>
      <QuestionChoice
        currentAnswer={currentAnswer}
        currentQuestion={currentQuestion}
        index={index}
        label={label}
        recordChoice={recordChoice}
      />
    </li>,
  );
  return (
    <div>
      <h3
        className={classnames({
          question: true,
        })}
        dangerouslySetInnerHTML={{
          __html: currentQuestion.fieldQuestion,
        }}
      />
      <div
        className={classnames({
          explanatory: true,
        })}
        dangerouslySetInnerHTML={{
          __html: currentQuestion.fieldExplanatoryText,
        }}
      />
      <ul
        className={classnames({
          questions: true,
        })}
      >
        { choices }
      </ul>
      <ButtonPrevious previousStep={previousStep} />
      <ButtonNext
        nextStep={nextStep}
        disabled={!isInteger(currentAnswer)}
      />
      <div
        style={{
          fontSize: '16px',
          color: '#aaa',
        }}
      >
        Question {currentPosition + 1} of {totalQuestions}
      </div>
    </div>
  );
}

Question.propTypes = {
  currentAnswer: PropTypes.number,
  currentPosition: PropTypes.number,
  currentQuestion: PropTypes.shape({}),
  nextStep: PropTypes.func,
  previousStep: PropTypes.func,
  recordChoice: PropTypes.func,
  totalQuestions: PropTypes.number,
};

export default Question;



// WEBPACK FOOTER //
// js/src/assessment/Question.js